import React, { useState, useEffect, useCallback } from "react";

import WebBarChart from "../../../../../elements/barChart";

import Loader from "../../../../../../settings/loader";

import commaNumber from "comma-number";

import "./style.scss";

const barColors = ["#FFA32E", "#E38029", "#FA8039", "#E6693C", "#FA684B"];

function Slider2(props) {
  const [data, setData] = useState({
    result: null,
    cols: [],
    chart: [],
    chains: [],
  });
  const [load, setLoad] = useState(0);

  // Initialize data
  useEffect(() => {
    if (props.data && load === 0) {
      setData((prev) => ({
        ...prev,
        result: props.data,
        cols: props.data.payType.data.map((data, key) => ({
          name: data.name,
          key: key,
        })),
        chains: props.data.chains.data.map((data, key) => ({
          name: data.name,
          braKey: data.braKey,
          chaKey: data.chaKey,
          key: key,
        })),
      }));
      setLoad(1);
    }
    // eslint-disable-next-line
  }, [props.data, load]);

  // Load chart data
  const loadData = useCallback(() => {
    if (!data.result) return;
    const chartData = data.result.chains.data
      .map((chain, idx) => {
        const payType = data.cols.map((pay) => ({
          ...pay,
          total: [].concat
            .apply(
              [],
              data.result.sales.data
                .filter(
                  (sale) =>
                    sale.payType.find((type) => type.name === pay.name) &&
                    sale.chaKey === chain.chaKey
                )
                .map((sale) => sale.payType)
            )
            .filter((s) => s.name === pay.name)
            .reduce((a, b) => a + b.amount, 0),
        }));

        const totalSales = payType.reduce((a, b) => a + b.total, 0);
        const label =
          data.result.brands.data.find((brand) => brand.braKey === chain.braKey)
            .name +
          " | " +
          chain.name;
        const currency = chain?.currency?.toUpperCase();

        return {
          y: totalSales,
          value: totalSales,
          label: label,
          name: label,
          displayValue: `${currency} ${totalSales?.toFixed(2)}`,
          currency: currency,
          openSales: `${currency} 0.00`,
          closedSales: `${currency} ${totalSales?.toFixed(2)}`,
          targetValue: `${currency} 0.00`,
          color: barColors[idx % barColors.length],
        };
      })
      .filter((d) => d.y);

    setData((prev) => ({
      ...prev,
      chart: chartData,
    }));
    setLoad(2);
    // eslint-disable-next-line
  }, [data.result, data.cols]);

  useEffect(() => {
    if (load === 1) {
      loadData();
    }
    // eslint-disable-next-line
  }, [load, loadData]);

  // Export logic
  useEffect(() => {
    if (props.export) {
      props.getData({
        type: "image",
        title: "Sales By Payment Type",
        filter: {
          brands: props.filter.data.brands.map((brand) => brand.name),
          chains: props.filter.data.chains.map((chain) => chain.name),
          revCent: props.filter.data.revCent.map((revCent) => revCent.name),
          payType: props.filter.data.payType.map((payType) => payType.name),
          date: {
            start: props.filter.data.date.start,
            end: props.filter.data.date.end,
          },
        },
        body: {
          table: [
            {
              head: [["Payment Type", "Total"]],
              body: [
                ...data.chart.map((d) => [
                  d.label,
                  `${d?.currency} ${commaNumber(d.y.toFixed(2))}`,
                ]),
              ],
            },
          ],
          id: "exportPdf_Slide3",
        },
      });
    }
    // eslint-disable-next-line
  }, [props.export, data.chart, props.getData]);

  return (
    <div id={"exportPdf_Slide3"}>
      {load < 2 ? (
        <Loader />
      ) : (
        <div
          style={{
            height: Math.max(data.chart.length * 60 || 0, 300),
            overflowY: "auto",
          }}
        >
          <WebBarChart chartData={data.chart} />
        </div>
      )}
    </div>
  );
}

export default Slider2;
